import { Component, inject, ViewChild } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { DatePipe } from '../../../pipes/date.pipe';
import { StatusChipComponent } from '../../../components/status-chip/status-chip.component';
import { EstimagePayInvoicesStore, SortedPagedRequest } from './estimage-pay-invoices.store';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import {
  EstimagePayInvoice,
  PaymentRequestStatusDescriptionEnum,
  PaymentRequestStatusEnum
} from './estimage-pay-invoices.model';
import { CurrentUserService } from '../../../services/currentUser.service';
import { Router } from '@angular/router';
import { InfosGuidanceComponent } from '../../../components/infos-guidance/infos-guidance.component';

@Component({
  selector: 'estimage-pay-invoice-table',
  imports: [
    MatProgressSpinnerModule,
    MatDividerModule,
    MatTableModule,
    CurrencyPipe,
    DatePipe,
    StatusChipComponent,
    MatPaginatorModule,
    InfosGuidanceComponent
  ],
  providers: [EstimagePayInvoicesStore],
  template: `
    <div class="space-y-20">
      <h3>EstImage Pay Factored Invoices</h3>

      <mat-divider />

      @if (estimagePayInvoicesStore.isLoading()) {
        <div class="flex justify-center py-20">
          <mat-spinner diameter="40" />
        </div>
      } @else {
        @if (!estimagePayInvoicesStore.totalInvoiceCount()) {
          <infos-guidance [guidanceTemplate]="noResults" />
        } @else {
          <div>
            <mat-paginator
              [length]="estimagePayInvoicesStore.totalInvoiceCount()"
              [pageSize]="pageSize"
              (page)="getInvoices()" />
            <table mat-table [dataSource]="estimagePayInvoicesStore.pagedInvoices()">
              <ng-container matColumnDef="acceptedOrRejectedDateTime">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let invoice">
                  {{ invoice.acceptedOrRejectedDateTime | dateepoch: currentUserTimezone }}
                </td>
              </ng-container>
              <ng-container matColumnDef="claimNumber">
                <th mat-header-cell *matHeaderCellDef>Claim Number</th>
                <td mat-cell *matCellDef="let invoice">{{ invoice.claimNumber }}</td>
              </ng-container>
              <ng-container matColumnDef="rego">
                <th mat-header-cell *matHeaderCellDef>Rego</th>
                <td mat-cell *matCellDef="let invoice">{{ invoice.rego }}</td>
              </ng-container>
              <ng-container matColumnDef="invoiceNumber">
                <th mat-header-cell *matHeaderCellDef>Invoice Number</th>
                <td mat-cell *matCellDef="let invoice">{{ invoice.invoiceNumber }}</td>
              </ng-container>
              <ng-container matColumnDef="invoiceTotalPayable">
                <th mat-header-cell *matHeaderCellDef class="text-end">Total Payable</th>
                <td mat-cell *matCellDef="let invoice" class="text-end">
                  {{ invoice.invoiceTotalPayable | currency }}
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentRequestStatus">
                <th mat-header-cell *matHeaderCellDef class="text-center">Payment Request Status</th>
                <td mat-cell *matCellDef="let invoice">
                  <div class="flex justify-center">
                    <status-chip [status]="PaymentRequestStatusEnum[invoice.paymentRequestStatus]" />
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentRequestStatusDescription">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let invoice">
                  {{ PaymentRequestStatusDescriptionEnum[invoice.paymentRequestStatus] }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let invoice; columns: displayedColumns"
                class="hover:cursor-pointer"
                (click)="navigateToJob(invoice)"></tr>
            </table>
          </div>
        }
        <ng-template #noResults>
          <div class="text-dove-gray text-[16px] py-20">There are no invoices factored through EstImage Pay</div>
        </ng-template>
      }
    </div>
  `,
  styles: [
    `
      .mat-column-paymentRequestStatusDescription {
        min-width: 480px;
        width: 40vw;
      }
    `
  ]
})
export class EstimagePayInvoiceTableComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  estimagePayInvoicesStore = inject(EstimagePayInvoicesStore);
  currentUserTimezone = inject(CurrentUserService).timeZone;
  #router = inject(Router);

  displayedColumns = [
    'acceptedOrRejectedDateTime',
    'claimNumber',
    'rego',
    'invoiceNumber',
    'invoiceTotalPayable',
    'paymentRequestStatus',
    'paymentRequestStatusDescription'
  ];
  pageSize = 50;
  PaymentRequestStatusEnum = PaymentRequestStatusEnum;
  PaymentRequestStatusDescriptionEnum = PaymentRequestStatusDescriptionEnum;

  getInvoices(): void {
    const request: SortedPagedRequest = {
      pageIndex: this.paginator.pageIndex
      // sortOrder: this.sort.direction,
      // sortColumn: this.sort.active
    };

    this.estimagePayInvoicesStore.getInvoices(request);
  }

  navigateToJob(invoice: EstimagePayInvoice): void {
    this.#router.navigate(['jobViewer', invoice.jobId]);
  }
}
